export const data2 = [
  "images/media/490412546_1075902477899423_2486554163063046665_n.jpg",
  "images/media/491407171_1075901987899472_7366721759405452896_n.jpg",
  "images/media/490811802_1075901414566196_1396350200746482633_n.jpg",
  "images/media/491037524_1075903831232621_87412957159767762_n.jpg",
  "images/media/490972008_1075903951232609_7927806265366270710_n.jpg",
  "images/media/490368476_1075901194566218_7991049299961079283_n.jpg",
  "images/media/490588616_1075903544565983_6400378921104029034_n.jpg",
  "images/media/490974485_1075901907899480_5452509492332231993_n.jpg",
  "images/media/490383222_1075903037899367_4343661712578598472_n.jpg",
  "images/media/491268365_1075904334565904_5840859038425742931_n.jpg",
  "images/media/491193052_1075904247899246_3567483476464790283_n.jpg",
  "images/media/490115067_1075900184566319_4209959973696341044_n.jpg",
];
